import { StyleSheet } from 'react-native';
import { neutrals, text } from 'src/theme/colors';

export const style = StyleSheet.create({
  container: {
    position: 'absolute',
    right: 36,
    bottom: 16,
    zIndex: 1,
    width: 369,
    borderRadius: 16,
    padding: 16,
    gap: 12,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: neutrals.white,
    shadowColor: neutrals.black,
    shadowOpacity: 0.15,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 12,
  },
  content: {
    gap: 16,
  },
  ctaContainer: {
    width: 209,
    flexDirection: 'row',
    gap: 8,
  },
  textContainer: {
    gap: 4,
  },
  title: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 22,
    color: text.color.textPrimary,
  },
  description: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 21,
    color: neutrals.neutralGrays.coal,
  },
});
